
import Milk from "../../../assets/filled/Milk.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MilkIcon({ className, dataTestid = "MilkIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Milk data-testid={dataTestid} className={classes} {...rest} />
  );
}
